// extracted by mini-css-extract-plugin
export default {"wrapper":"NFTS_wrapper__1al62","slider":"NFTS_slider__d-kLX"};